
import { Badge } from "@/components/ui/badge";

interface BlogPostTagsProps {
  tags: string[];
}

export const BlogPostTags = ({ tags }: BlogPostTagsProps) => {
  if (!tags || tags.length === 0) return null;
  
  return (
    <div className="mb-10">
      <h3 className="text-lg font-medium mb-3">Tag</h3>
      <div className="flex flex-wrap gap-2">
        {tags.map(tag => (
          <Badge key={tag} variant="outline" className="bg-background hover:bg-muted cursor-pointer">
            #{tag}
          </Badge>
        ))}
      </div>
    </div>
  );
};
